




























import {Component, Vue} from "vue-property-decorator";
import {RhizomeViewType} from "@/modules/Rhizome/interfaces/state.interface";
import {EventEmitter} from "@/interfaces/store-interfaces/event-emitter.interface";
import {localStorageService} from "@/services/local-storage.service";
import {bus} from "@/plugins/bus";

@Component({})
export default class ScreensaverManager extends Vue {

  inactivityIntervalId = null;
  screensaverIntervalId = null;
  lastInteractionTime: number = Date.now();
  warningTimeout: number;
  countdownTime: number;
  screensaverTimeout: number;
  lingerTimeout: number;
  showWarningModal = false;
  screensaverEnabled = false;
  bypass = false;
  disabled = false;
  secondsLeft = 0;
  viewChangeThresh = 5;
  viewChangeCounter = 0;
  lastFilmIndex: number = null;

  get activeView(): RhizomeViewType {
    return this.$store.state.rhizome.viewType;
  }

  set activeView(value: RhizomeViewType) {
    this.$store.commit('rhizome/setPropertyInState', { name: 'viewType', value });
  }

  beforeMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const modalParam = urlParams.get('modal');
    if (modalParam === 'true') {
      this.disabled = true;
      return;
    }
  }

  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const timeoutParam = urlParams.get('timeout');
    const countdownParam = urlParams.get('countdown');
    const intervalParam = urlParams.get('interval');

    this.warningTimeout = (timeoutParam ? Number(timeoutParam) : 60) * 1000;
    this.countdownTime = (countdownParam ? Number(countdownParam) : 30) * 1000;
    this.screensaverTimeout = this.warningTimeout + this.countdownTime;
    this.lingerTimeout = (intervalParam ? Number(intervalParam) : 10) * 1000;

    window.addEventListener('pointerdown', this.onPointerDown);
    window.addEventListener('scroll', this.onPointerDown);

    bus.$on(EventEmitter.Events.SCREENSAVER_ACTIVE, this.onScreensaverActive);

    if (this.disabled) return;

    window.addEventListener("message", this.onModalMessage, false);

    this.init();
  }

  destroyed() {
    window.removeEventListener('pointerdown', this.onPointerDown);
    window.removeEventListener('scroll', this.onPointerDown);

    bus.$off(EventEmitter.Events.SCREENSAVER_ACTIVE, this.onScreensaverActive);

    if (this.disabled) return;

    window.removeEventListener('message', this.onModalMessage);

    if (this.screensaverIntervalId !== null) {
      clearInterval(this.screensaverIntervalId);
    }

    if (this.inactivityIntervalId !== null) {
      clearInterval(this.inactivityIntervalId);
    }

    if (this.showWarningModal) {
      this.showWarningModal = false;
    }

    if (this.screensaverEnabled) {
      this.screensaverEnabled = false;
    }
  }

  async onModalMessage(event) {
    if (event.origin === window.location.origin) {
      switch (event.data.action) {
        case 'screensaver-touch':
          this.onPointerDown();
          return;
        case 'screensaver-active':
          this.onScreensaverActive(event.data.payload);
          return;
      }
    }
  }

  activate() {
    if (!this.screensaverEnabled) {
      this.lastInteractionTime = Date.now();
      this.screensaverEnabled = false;
      this.showWarningModal = false;
      this.screensaverEnabled = false;
    }
    this.bypass = false
  }

  deactivate() {
    this.lastInteractionTime = Date.now();
    this.screensaverEnabled = false;
    this.showWarningModal = false;
    this.screensaverEnabled = false;
    this.bypass = true
  }

  init() {
    if (this.inactivityIntervalId !== null) {
      clearInterval(this.inactivityIntervalId);
    }

    this.inactivityIntervalId = setInterval(() => {
      if (this.bypass) {
        return
      }

      const now = Date.now()

      const diff = now - this.lastInteractionTime;

      this.secondsLeft = Math.floor(((this.lastInteractionTime + this.screensaverTimeout) - now) / 1000) + 1;

      if (!this.showWarningModal && !this.screensaverEnabled) {
        if (diff > this.warningTimeout) {
          this.showWarningModal = true;
        }
      } else if (this.showWarningModal) {
        if (diff > this.screensaverTimeout) {
          this.showWarningModal = false;
          this.screensaverEnabled = true;
          this.startScreensaver();
        }
      }
    }, 1000);
  }

  onScreensaverActive(state) {
    if (this.disabled) {
      top.postMessage({
        action: 'screensaver-active',
        payload: state
      }, window.location.origin);
      return;
    }

    if (state) {
      this.activate();
    } else {
      this.deactivate();
    }
  }

  onPointerDown() {
    if (this.disabled) {
      top.postMessage({ action: 'screensaver-touch' }, window.location.origin);
      return;
    }

    this.lastInteractionTime = Date.now();

    if (this.screensaverIntervalId !== null) {
      clearInterval(this.screensaverIntervalId);
    }

    if (this.showWarningModal) {
      this.showWarningModal = false;
    }

    if (this.screensaverEnabled) {
      this.screensaverEnabled = false;
    }
  }

  openHelpModal() {
    this.$store.dispatch('rhizome/openHelpModal');
  }

  async doNext() {
    this.viewChangeCounter++;
    if (this.viewChangeCounter % this.viewChangeThresh === 0 && Math.random() < 0.5) {
      this.viewChangeCounter = 0;
      // Clear active and change view
      bus.$emit(EventEmitter.Events.SET_ACTIVE_FILM, { filmID: null });
      if (this.activeView === RhizomeViewType.CLOUD) {
        this.activeView = RhizomeViewType.CIRCLE;
      } else {
        this.activeView = RhizomeViewType.CLOUD;
      }

      // wait for new view to settle
      await new Promise((resolve) => { setTimeout(() => {
        resolve(null)}, 2000);
      });

      // ensure we are still in screensaver mode after delay
      if (!this.screensaverEnabled) {
        return;
      }
    }

    // Pick random film
    let randIndex = this.lastFilmIndex;
    while (randIndex === this.lastFilmIndex) {
      randIndex = Math.round(Math.random() * (this.$store.state.rhizome.filmsList.length - 1));
    }

    this.lastFilmIndex = randIndex;

    const filmID = this.$store.state.rhizome.filmsList[randIndex].id;

    bus.$emit(EventEmitter.Events.SET_ACTIVE_FILM, { filmID });
  }

  startScreensaver() {
    // 1) switch to cloud view if not already there
    if (this.activeView !== RhizomeViewType.CLOUD) {
      this.activeView = RhizomeViewType.CLOUD;
    }

    // 2) close any modals that may be open
    this.$store.dispatch('rhizome/closeAllModals');

    // 3) clear any filters
    bus.$emit(EventEmitter.Events.SET_KEYWORD, null);

    // 4) start auto-pilot
    setTimeout(() => {
      if (!this.screensaverEnabled) return;
      this.doNext();     

      // start interval
      this.screensaverIntervalId = setInterval(() => {
        if (!this.screensaverEnabled) return;
        this.doNext();
      }, this.lingerTimeout);

      // reset zoom
      setTimeout(() => {
        if (this.screensaverEnabled) {
          bus.$emit(EventEmitter.Events.RESET_ZOOM);
        }
      }, 2000);   
    }, 200);

    // clear history
    localStorageService.clearHistoryList();
  }
}
